import mutations from './mutations';

const state = () => ({
    i_lang: localStorage.getItem("i_lang") || "tr"
});

const getters = {
    i_lang: state => state.i_lang,
};

const actions = {
    setLang({ commit }, value) {
        commit('setLang', value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};